import { Flexbox } from '@hiiretail/synergy-ui';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -124;
  }
`;

const color = keyframes`
  0% {
    stroke: #6E33A9;
  }
  40% {
    stroke: #6E33A9;
  }
  66% {
    stroke: #6E33A9;
  }
  80%, 90% {
    stroke: #6E33A9;
  }
`;

export const LoaderWrapper = styled(Flexbox)``;

export const LoaderIconWrapper = styled(Flexbox)`
  width: 200px;
  height: 200px;
  z-index: 9000;
`;

export const CircularLoader = styled.svg`
  -webkit-animation: rotate 2s linear infinite;
  animation: ${rotate} 2s linear infinite;
  height: 100%;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  width: 100%;
`;

export const LoaderPath = styled.circle`
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  -webkit-animation: ${dash} 1.5s ease-in-out infinite, ${color} 6s ease-in-out infinite;
  animation: ${dash} 1.5s ease-in-out infinite, ${color} 6s ease-in-out infinite;
  stroke-linecap: round;
`;
